import React from "react";

import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    body1Regular: React.CSSProperties;
    body1Medium: React.CSSProperties;
    body1SemiBold: React.CSSProperties;
    body2Regular: React.CSSProperties;
    body2Medium: React.CSSProperties;
    body2SemiBold: React.CSSProperties;
    body3Regular: React.CSSProperties;
    body3Medium: React.CSSProperties;
    body3SemiBold: React.CSSProperties;
    body4Regular: React.CSSProperties;
    body4Medium: React.CSSProperties;
    body4SemiBold: React.CSSProperties;
    subtitle1semiBold: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    body1Regular?: React.CSSProperties;
    body1Medium?: React.CSSProperties;
    body1SemiBold?: React.CSSProperties;
    body2Regular?: React.CSSProperties;
    body2Medium?: React.CSSProperties;
    body2SemiBold?: React.CSSProperties;
    body3Regular?: React.CSSProperties;
    body3Medium?: React.CSSProperties;
    body3SemiBold?: React.CSSProperties;
    body4Regular?: React.CSSProperties;
    body4Medium?: React.CSSProperties;
    body4SemiBold?: React.CSSProperties;
  }

  interface BreakpointOverrides {
    xs0: true;
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    body1Regular: true;
    body1Medium: true;
    body1SemiBold: true;
    body2Regular: true;
    body2Medium: true;
    body2SemiBold: true;
    body3Regular: true;
    body3Medium: true;
    body3SemiBold: true;
    body4Regular: true;
    body4Medium: true;
    body4SemiBold: true;
  }
}

export const muiThemeOverride = createTheme({
  breakpoints: {
    values: {
      xs0: 0,
      xs: 360,
      sm: 600,
      md: 840,
      md480: 480,
      md680: 680,
      md920: 920,
      lg: 1440,
      xl: 1920
    }
  },
  typography: {
    fontFamily: '"Inter", system-ui',

    // Headings
    h1: {
      fontSize: "96px",
      fontWeight: 600,
      lineHeight: "128px",
      letterSpacing: "-1.5px"
    },
    h2: {
      fontSize: "64px",
      fontWeight: 600,
      lineHeight: "80px",
      letterSpacing: "-1.5px"
    },
    h3: { fontSize: "48px", fontWeight: 600, lineHeight: "64px" },
    h4: {
      fontSize: "32px",
      fontWeight: 600,
      lineHeight: "40px",
      letterSpacing: "0.25px"
    },
    h5: { fontSize: "24px", fontWeight: 500, lineHeight: "32px" },
    h6: {
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: "0.15px"
    },

    // Custom body variants
    body1Regular: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "20px",
      letterSpacing: "0.15px"
    },
    body1Medium: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "20px",
      letterSpacing: "0.15px"
    },
    body1SemiBold: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "20px",
      letterSpacing: "0.15px"
    },

    body2Regular: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      letterSpacing: "0.1px"
    },
    body2Medium: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
      letterSpacing: "0.1px"
    },
    body2SemiBold: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      letterSpacing: "0.1px"
    },

    body3Regular: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: "0.4px"
    },
    body3Medium: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
      letterSpacing: "0.4px"
    },
    body3SemiBold: {
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: "16px",
      letterSpacing: "0.4px"
    },

    body4Regular: {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "12px",
      letterSpacing: "1px"
    },
    body4Medium: {
      fontSize: "10px",
      fontWeight: 500,
      lineHeight: "12px",
      letterSpacing: "1px"
    },
    body4SemiBold: {
      fontSize: "10px",
      fontWeight: 600,
      lineHeight: "12px",
      letterSpacing: "1px"
    }
  },

  components: {
    MuiDialog: {
      defaultProps: {
        closeAfterTransition: false,
        "aria-hidden": false
      }
    },
    MuiMenu: {
      defaultProps: {
        "aria-hidden": false
      }
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          maxHeight: "0.01em"
        }
      }
    }
  }
});
